import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import KnowledgeCopyrightService from "../../../../../services/KnowledgeCopyrightService";
import PageComponent from "../../../page/PageComponent";
import AdditionalData from "./AdditionalData";

class AdditionalDataContaier extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      knowledgeCopyrights: [],
      knowledgeTags: [],
      tagsChanged: false
    };

    this.knowledgeCopyrightService = new KnowledgeCopyrightService(
      this.keycloak
    );
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadKnowledgeCopyrights();
  }
  loadKnowledgeCopyrights = () => {
    this.prepareCall(
      this.knowledgeCopyrightService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onKnowledgeCopyrightsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeCopyrightsLoad = data => {
    const knowledgeCopyrights = data._embedded ? data._embedded.content : [];
    this.setState({ knowledgeCopyrights: knowledgeCopyrights });
  };

  onAddToTag = tagName => {
    tagName = tagName && tagName.toUpperCase();
    const tags = [...this.props.knowledgeItem.tags];
    const autoTags = [...this.props.knowledgeItem.autoTags];

    const tagExists = tags
      .map(element => element.name)
      .map(name => name.toUpperCase())
      .some(name => name === tagName);

    if (!tagExists) {
      const autoTagIndex = autoTags.findIndex(
        tag => tag.name.toUpperCase() === tagName
      );
      autoTags[autoTagIndex].hideAdd = true;
      const tag = { name: tagName };
      tags.push(tag);
      this.props.onChange({ target: { id: "tags", value: tags } });
      this.props.onChange({ target: { id: "autoTags", value: autoTags } });
      this.setState({ tagsChanged: true });
    }
  };

  onRemoveTag = tagName => {
    tagName = tagName && tagName.toUpperCase();
    const autoTags = [...this.props.knowledgeItem.autoTags];
    const autoTagIndex = autoTags.findIndex(
      tag => tag.name.toUpperCase() === tagName
    );

    if (autoTagIndex >= 0) {
      autoTags[autoTagIndex].hideAdd = false;
      this.props.onChange({ target: { id: "autoTags", value: autoTags } });
      this.setState({ tagsChanged: true });
    }
  };

  disableChanged = () => {
    this.setState({ tagsChanged: false });
  };

  render() {
    return (
      <AdditionalData
        knowledgeCopyrights={this.state.knowledgeCopyrights}
        validationRules={this.props.validationRules}
        processes={this.props.processes}
        onChange={this.props.onChange}
        knowledgeItem={this.props.knowledgeItem}
        editable={this.props.editable}
        onAddToTag={this.onAddToTag}
        disableChanged={this.disableChanged}
        tagsChanged={this.state.tagsChanged}
        onRemoveTag={this.onRemoveTag}
      />
    );
  }
}

export default withKeycloak(AdditionalDataContaier);
